module.exports = __webpack_public_path__ + "img/polygon_matic.5453872f.svg";